import React from 'react';
import { Radio } from 'js/components/common/Fields/Radio';
import { Textarea } from 'js/components/common/Fields/Textarea';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import { OTHER_REASON } from '../../constants';

import style from './Reasons.scss';

export const Reasons = ({ reasons, translate, description }) => {
    const { unsubscribeReasons: { other } } = useComponentConfig();

    return (
        reasons.length
            ? (
                <div className={style.reasons}>
                    <p className={style.subTitle}>{translate('reasons.title')}</p>
                    {reasons.map(reason => (
                        <Radio
                            wrapText
                            key={reason}
                            value={reason}
                            label={reason}
                            aria-label={reason}
                            name="description"
                        />
                    ))}
                    {other && (
                        <>
                            <Radio
                                wrapText
                                name="description"
                                value={OTHER_REASON}
                                label={translate('reasons.other')}
                                aria-label={translate(['reasons.other', 'playtech.mobile.system.radio.aria-label'])}
                            />

                            {description === OTHER_REASON && (
                                <Textarea
                                    name="other"
                                    maxLength={256}
                                    showMaxLengthHint
                                    className={style.other}
                                    classNames={{
                                        validationIcon: style.noValidation,
                                        content: style.content,
                                        control: style.control
                                    }}
                                    placeholder={translate('reasons.other.placeholder')}
                                    aria-label={translate(['reasons.other.placeholder', 'playtech.mobile.system.textarea.aria-label'])}
                                />
                            )}
                        </>
                    )}
                </div>
            )
            : null
    );
};
